/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_2_IntroInputs */

const en_privacy_section_2_intro = /** @type {(inputs: Privacy_Section_2_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We may collect the following types of personal data:`)
};

const lv_privacy_section_2_intro = /** @type {(inputs: Privacy_Section_2_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mēs varam apkopot šādus personas datu veidus:`)
};

/**
* | output |
* | --- |
* | "We may collect the following types of personal data:" |
*
* @param {Privacy_Section_2_IntroInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_2_intro = /** @type {((inputs?: Privacy_Section_2_IntroInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_2_IntroInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_2_intro(inputs)
	return en_privacy_section_2_intro(inputs)
});